import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Spinner, Table
} from "react-bootstrap";
import Tooltip from "@mui/material/Tooltip";
//icon
import { LiaUserAstronautSolid } from "react-icons/lia";
import { SlOptions } from "react-icons/sl";
import { useLanguage } from "../../../Language/LanguageContext";


export default function CertificateManager(props) {
    const Navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { t } = useLanguage();

    useEffect(() => {
        if (!loading) {
            return (
                <>
                    <h2 className="profile-header">จัดการใบอนุญาต</h2>
                    <div className="loading-container" style={{ height: "240px" }}>
                        {" "}
                        <Spinner animation="border" variant="secondary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>
                </>
            );
        }
        setTimeout(() => {
            setLoading(true)
        }, 2000);
    }, [loading]);

    return (
        <>
            <h2 className="profile-header">จัดการใบอนุญาต</h2>
            <div className="user-deshboard" >
                <div className="user-desh-left" >
                    <div className="user-desh-box" >
                        <div className="user-desh-title">
                            <h5 className="font-cen form-label" style={{ fontSize: 24 }}>ใบอนุญาตโดรน</h5>
                        </div>
                        <div style={{ maxHeight: "350px", overflowY: "auto", marginTop: "30px" }}>
                            <label>Body</label>
                        </div>

                    </div>
                </div>

                <div className="user-desh-right">
                    <div className="user-desh-box account">
                        <div className="user-desh-title">

                            <div className="user-desh-title">
                                <Tooltip
                                    title={
                                        <span style={{ fontSize: "16px", fontFamily: "Kanit" }}>
                                            แก้ไข
                                        </span>
                                    }
                                    placement="top"
                                >
                                    <a href="/user/pilot/regispilotspacific" className="btn-more">
                                        <i className="dash-more">
                                            <SlOptions size={21} />
                                        </i>
                                    </a>
                                </Tooltip>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <LiaUserAstronautSolid style={{ width: "25px", height: "25px" }} />
                                    <h5 className="font-cen form-label" style={{ marginBottom: 0, marginLeft: 10, fontSize: 24 }}>ใบอนุญาตนักบินขั้นสูง</h5>
                                </div>
                            </div>
                            <body style={{ marginTop: 10, backgroundColor: "transparent" }}>
                                <div
                                    style={{
                                        margin: "0px auto",
                                        padding: "20px",
                                        background:
                                            "linear-gradient(101.27deg, #8A024B 0%, #C78300 100%)",
                                        borderRadius: "20px",

                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            textAlign: "center",
                                        }}
                                    >
                                        <h4 style={{ color: "white" }}>
                                            UAV Pilot License
                                        </h4>
                                        <h6
                                            style={{
                                                color: "white",
                                            }}
                                        >
                                            Kingdom of Thailand
                                        </h6>
                                        <img
                                            src={
                                                "https://images.emojiterra.com/openmoji/v13.1/512px/1f1f9-1f1ed.png"
                                            }
                                            alt="thailand"
                                            style={{
                                                width: "100px",
                                                height: "100px",
                                            }}
                                        />
                                    </div>

                                    <p style={{ color: "white" }}>
                                        {t("managementpilot.type")} : OPEN AND SPECIFIC
                                    </p>

                                    <p style={{ color: "white" }}>
                                        {t("managementpilot.number")} : 1111222333
                                    </p>

                                    <p style={{ color: "white" }}>
                                        {t("managementpilot.codeOpen")} :{" "}
                                        ABCDEFGHIJKLMNOPQRSTUVWXYZ
                                    </p>
                                    <p style={{ color: "white" }}>
                                        {t("managementpilot.codeSpec")} :{" "}
                                        ABCDEFGHIJKLMNOPQRSTUVWXYZ
                                    </p>
                                

                                    <div
                                        style={{
                                            display: "flex",
                                            position: "absolute",
                                            bottom: "25px",
                                            right: "50px",
                                        }}
                                    >

                                    </div>


                                </div>

                            </body>

                        </div>
                        <div>

                        </div>
                    </div>
                    <div className="user-desh-box logged">
                    {/* <p className="font-cen form-label" >ชื่อ-นามสกุล :</p> */}
                                    {/* <p className="font-cen form-label">วันเริ่มต้น :</p>
                                <p className="font-cen form-label">วันสิ้นสุด :</p> */}
                                    <p className="font-cen form-label" >สถานะ :</p>
                                    {/* <p className="font-cen form-label">หมายเหตุ :</p> */}
                                    <p className="font-cen form-label" >อัพเดทล่าสุด :</p>
                    </div>
               

                </div>
            </div>
        </>
    );

};


